export default "__VITE_ASSET__35a9530e__"